module.exports = __webpack_public_path__ + "img/pattern1 copy 8.22e48615.svg";